import { useMutation, useQueryClient } from '@tanstack/react-query';
import { consumerApi, consumerPlanKeys, type PremiumRangeRequest } from '../api/consumer-api';

export function usePremiumRangeRequest(clientId: string) {
  return useMutation({
    mutationFn: (request: PremiumRangeRequest) => consumerApi.requestPremiumRange(clientId, request),
  });
}

export function useSubmitApplication(clientId: string) {
  return useMutation({
    mutationFn: (body: {
      coverage: ConsumerApplicationCoverage;
      answers: ConsumerApplicationAnswers;
      consentIds: string[];
    }) =>
      consumerApi.submitApplication(clientId, body),
  });
}

/**
 * Puts a sent application into the cached plan. Done by the sender rather than by refetching, so it
 * lands after the completion that sending records: a plan showing an application but no completion
 * looks like a consumer who applied before completion existed, and would be stamped a second time.
 */
export function useAddSentApplication(clientId: string) {
  const queryClient = useQueryClient();
  return (submission: ConsumerApplicationSubmission) =>
    queryClient.setQueryData<ConsumerPlanResponse>(consumerPlanKeys.detail(clientId), plan =>
      plan ? { ...plan, applications: [submission, ...plan.applications] } : plan,
    );
}
